export const BUSINESS_PROFILE_INDEX_PAGE_CONTAINER_TEST_ID =
  'business-profile-page-index-page-container'

export const EDIT_PROFILE_SHEET_CONTAINER_TEST_ID =
  'edit-profile-sheet-container'

export const BACKGROUND_PHOTO_TEST_ID = 'background-photo-container'

export const VIEW_PROFILE_CARD_TEST_ID = 'view-profile-card'
export const LOADING_SPINNER_TEST_ID = 'loading-spinner'
export const SUBSCRIPTION_BUTTON_TEST_ID = 'subscription-button'
export const PAY_BUTTON_TEST_ID = 'pay-button'

export const BUSINESS_PROFILE_HEADER_SECTION_TEST_ID =
  'business-profile-header-section'
export const UNPUBLISHED_PROFILE_WARNING_ALERT_TEST_ID =
  'unpublished-profile-warning-alert'

export const PREVIEW_PROFILE_PAGE_TEST_ID = 'preview-profile-page'
export const EDIT_PROFILE_PAGE_TEST_ID = 'edit-profile-page'

export const OWNER_PROFILE_SCREEN_INDEX_CONTAINER_TEST_ID =
  'owner-profile-screen-index-container'
export const EDIT_PROFILE_PANEL_TEST_ID = 'edit-profile-panel'
export const BUSINESS_NAME_SECTION_TEST_ID = 'business-name-section'
export const BUSINESS_DESCRIPTION_SECTION_TEST_ID =
  'business-description-section'
export const BUSINESS_USERNAME_SECTION_TEST_ID = 'business-username-section'

export const PREVIEW_PROFILE_BUTTON_TEST_ID = 'preview-profile-button'

export const EDIT_BIZ_INFO_PAGE_COMPONENT_TEST_ID =
  'edit-biz-info-page-component'

export const EDIT_DESCRIPTION_PAGE_COMPONENT_TEST_ID =
  'edit-description-page-component'
